import React, { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import {
  LOCATION_NEAR_BY_LOCATION_URL,
  RECORDS_FETCH_LIMIT,
  NEAR_BY_SEARCH_DISTANCE,
  MARKER_BROWN_URL,
} from "../../config";

import makeApiRequest from "../../utils/axios/new-axios";
import ComponentLoader from "../loader/ComponentLoader";
import GoogleMap from "../google/GoogleMap";
import Marker from "../google/Marker";
import InfoWindowSimple from "../google/InfoWindowSimple";
import InfoWindowLoc from "../google/InfoWindowLoc";
import MergeLocForm from "../../components/location/MergeLocForm";
import { showErrorAlert } from "../../store/actions/alerts";
import { permissions, types, checkAcl } from "../../utils/acl";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function MapPanel({ locationId, mapCoords }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const EDIT_ACCESS = checkAcl({ p: permissions.LOCATION_MANAGEMENT, t: types.VIEW_AND_EDIT });

  const [mapDetails, setMapDetails] = useState(null);
  const [mapCoordsPrevious, setMapCoordsPrevious] = useState(null);
  const [isLoadingMap, setIsLoadingMap] = useState(true); //set to true for the initial loading
  const [mergeTo, setMergeTo] = useState(null);
  const [openMergeModal, setOpenMergeModal] = useState(false);
  const [showMap, setShowMap] = useState(false);

  function handleMergeClick(selectedIndex) {
    if (EDIT_ACCESS) {
      setMergeTo(selectedIndex);
      handleOpenMergeModal();
    } else {
      dispatch(showErrorAlert("You do not have access to this feature. Contact administrator"))
    }
  }

  function handleOpenMergeModal() {
    setOpenMergeModal(true);
  }

  function handleCloseMergeModal() {
    setOpenMergeModal(false);
  }

  useEffect(() => {
    if (
      !!locationId &&
      !!mapCoords &&
      (!mapCoordsPrevious ||
        mapCoords.lat !== mapCoordsPrevious.lat ||
        mapCoords.lng !== mapCoordsPrevious.lng)
    ) {
      setMapCoordsPrevious({ ...mapCoords });
      setIsLoadingMap(true);
      makeApiRequest({
        url: `${LOCATION_NEAR_BY_LOCATION_URL.url}/${locationId}`,
        method: LOCATION_NEAR_BY_LOCATION_URL.method,
        params: {
          distance: NEAR_BY_SEARCH_DISTANCE,
          limit: RECORDS_FETCH_LIMIT,
          page: 1,
        },
      })
        .then((response) => {
          setIsLoadingMap(false);
          setMapDetails(response.data);
        })
        .catch((error) => {
          setIsLoadingMap(false);
          dispatch(
            showErrorAlert(
              "Location Fetch Error : " +
              (!!error.response
                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                : error.message)
            )
          );
        });
    } else {
      setMapCoordsPrevious({ ...mapCoords });
    }
    // eslint-disable-next-line
  }, [locationId, mapCoords]);

  return (
    <Fragment>
      <Accordion expanded>
        <AccordionSummary
          aria-controls="adm-detail-content"
          id="adm-detail-header"
        >
          <Typography className={classes.heading}>Map</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box component="span" display="block" width="100%">
            <ComponentLoader isLoading={isLoadingMap} />
            {!!mapCoords && !!mapDetails && !isLoadingMap && (
              <Fragment>
                {!!mapDetails.locations && mapDetails.locations.length > 0 && (
                  <Box
                    justifyContent="center"
                    display="flex"
                    style={{ marginBottom: "15px" }}
                  >
                    Nearby location(s) found. Click on the nearby location to
                    merge.
                  </Box>
                )}
                <Fragment>
                  {!!showMap ? (
                    <GoogleMap
                      id="google-map"
                      width="100%"
                      height="400px"
                      options={{
                        center: mapDetails.coordinates,
                        zoom: 16,
                        streetViewControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false,
                      }}
                    >
                      <Marker
                        id={mapDetails.id}
                        position={mapDetails.coordinates}
                        options={{
                          zIndex: 100,
                        }}
                        infoWindow={
                          <InfoWindowSimple
                            title={mapDetails.name}
                            detail={mapDetails.address}
                          />
                        }
                        defaultOpen
                      />
                      {!!mapDetails.locations &&
                        mapDetails.locations.map((location) => {
                          return (
                            <Marker
                              id={location.id}
                              key={location.id}
                              position={location.coordinates}
                              options={{
                                icon: MARKER_BROWN_URL,
                              }}
                              infoWindow={
                                <InfoWindowLoc
                                  title={`${location.name} (${location.id})`}
                                  titleLink={`/location/${location.id}`}
                                  detail={location.address}
                                  mediaId={location.mediaId}
                                  status={location.status}
                                  buttonLabel={"Merge To This Location"}
                                  handleClick={handleMergeClick}
                                  selectedIndex={location.id}
                                />
                              }
                            />
                          );
                        })}
                    </GoogleMap>
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="row"
                      justifyContent="center"
                    >
                      <Button
                        color="primary"
                        size="small"
                        variant="outlined"
                        onClick={() => setShowMap(true)}
                      >
                        Show
                      </Button>
                    </Box>
                  )}
                </Fragment>
              </Fragment>
            )}
          </Box>
        </AccordionDetails>
      </Accordion>
      {!!mapDetails && !!mergeTo && (
        <MergeLocForm
          openModal={openMergeModal}
          handleCloseModal={handleCloseMergeModal}
          locationId={mapDetails.id}
          locationName={mapDetails.name}
          mergeTo={mergeTo}
        />
      )}
    </Fragment>
  );
}
